<template>
  <div>
    <qb-table>
      <template v-slot:thead>
        <qb-tr style="width: 100%">
          <qb-th class="f-14" style="width: 20%">
            {{ $t('client') | capitalize }}
          </qb-th>
          <qb-th class="f-14" style="width: 15%">
            {{ $tc('facility', 1) | capitalize }}
          </qb-th>
          <qb-th class="f-14" style="width: 30%">
            {{ $t('title') | capitalize }}
          </qb-th>
          <qb-th class="f-14" style="width: 10%">{{ $t('expiration_date') | capitalize }}
          </qb-th>
          <qb-th class="f-14" style="width: 20%">
            {{ $t('comment') | capitalize }}
          </qb-th>
          <qb-th class="f-14" style="width: 5%"></qb-th>
        </qb-tr>
      </template>
      <template v-slot:tbody>
        <qb-tr v-for="(el, idx) in data" :key="idx">
          <qb-td>{{ el.client_name | capitalize }}</qb-td>
          <qb-td>{{ el.building_number | capitalize }}</qb-td>
          <qb-td>
            <qb-td>{{ el.name[0] | capitalize }} <br/> {{ el.name[1] }}</qb-td>
            <span
              class="material-icons sm"
              :style="{
                fontSize: '8px',
                color: '#14AFDC',
              }"
            >
              lens
            </span>
            {{ el.category_name | upperCase }}
            
          </qb-td>
          <qb-td class="text-center">
            <vs-chip :color="el.status_color" class="chip-status text-center w-full">
              {{ el.status_ehs | upperCase }} <br />
              {{ formatDate(el.date_expiration) }}
            </vs-chip>
          </qb-td>
          <qb-td>{{ el.observations[0] | capitalize }} <br/> {{ el.observations[1] }}</qb-td>
          <qb-td>
            <action-icon
              icon="SidebarIcon"
              :tooltip="$t('details') | capitalize"
              @click="showDetails(el)"
          /></qb-td>
        </qb-tr>
        <qb-tr>
          <qb-td colspan="100%">
            <div
              v-if="data.length"
              v-observe-visibility="infiniteHandler"
            ></div>
          </qb-td>
        </qb-tr>
      </template>
    </qb-table>
  </div>
</template>

<script>
import QbTable from '@/views/qb-components/table/QbTable.vue'
import QbTr from '@/views/qb-components/table/QbTr.vue'
import QbTh from '@/views/qb-components/table/QbTh.vue'
import QbTd from '@/views/qb-components/table/QbTd.vue'
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
export default {
  name: 'ehs-table',
  components: {
    ActionIcon,
    QbTable,
    QbTr,
    QbTh,
    QbTd,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    showDetails(item) {
      this.$emit('showDetails', item.id)
    },
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    }
  },
}
</script>

<style>
.chip-status {
  max-width: 9rem;
  min-width: 2rem;
  color: white;
  text-align: center;
  border-radius: 0.3em;
}
</style>
